export default {
    init() {
        const hero = document.querySelector('[data-hero-about]')

        if (hero) {
            const logoBackground = hero.querySelector('[data-logo-background]')
            const image = hero.querySelector('[data-image-container]')

            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: hero,
                    scrub: true,
                    start: 'top top',
                    end: 'bottom top',
                },
            })

            parallax
                .fromTo(
                    logoBackground,
                    {
                        y: '-20%',
                    },
                    {
                        y: '10%',
                        ease: 'none',
                    },
                )
                .fromTo(
                    image,
                    {
                        y: '0%',
                    },
                    {
                        y: '-32%',
                        ease: 'none',
                    },
                    '<0',
                )
        }
    },
}
